import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currencySymbol, setCurrencySymbol] = useState(localStorage.getItem("currency")||"");
  const [currencySeparator, setcurrencySeparator] = useState(localStorage.getItem("currencySeparator")||"");

  

  const updateCurrency = (newCurrency) => {
    setCurrencySymbol(newCurrency);
    localStorage.setItem("currency", newCurrency);
  };

  const updateCurrencySeparator = (newCurrency) => {
    setcurrencySeparator(newCurrency);
    
    localStorage.setItem("currencySeparator", newCurrency);
  };



  return (
    <CurrencyContext.Provider value={{ currencySymbol, updateCurrency,currencySeparator,updateCurrencySeparator }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useStandard must be used within a CurrencyContext');
  } 
  return context;
};
